export default __webpack_public_path__ + "static/media/Typomenes_tainies.b3b6da35.jpg";